<template>
    <div>
        <router-link to="/logmonitoring/indicatorForm" class="routerLink">
            <base-button
                @click="openModal()"
                :type="currentRoute=='master'?'info':'primary'"
                class="addIndicatorBtn"
                >Indicator Master</base-button
            ></router-link
        >
        <!-- <router-link to="/logmonitoring/monitoringForm" class="routerLink"> -->
        <router-link to="/logmonitoring/addmonitoringForm" class="routerLink">
            <base-button  :type="currentRoute=='monitoring'?'info':'primary'" class="addIndicatorBtn"
                >Indicator Monitoring</base-button
            ></router-link
        >
        <router-link to="/logmonitoring/reports" class="routerLink">
            <base-button  :type="currentRoute=='reports'?'info':'primary'" class="addIndicatorBtn"
                >Reports</base-button
            ></router-link
        >
        <router-view></router-view>
    </div>
</template>
<style lang="scss" scoped>

.routerLink{
    padding-right: 10px;
}
</style>
<script>
import IndicatorForm from "@/components/LogMonitoring/IndicatorForm";
import MonitoringForm from "@/components/LogMonitoring/MonitoringForm";
export default {
    components: {
        IndicatorForm,
        MonitoringForm,
    },
    data() {
        return {
            showMonitoringForm: false,
            currentRoute:"master"
        };
    },
    mounted(){
        if(this.$route.path=="/logmonitoring/indicatorForm"){
                this.currentRoute="master"
            }
            else if(this.$route.path=="/logmonitoring/addmonitoringForm"){
                this.currentRoute="monitoring"
            }
            else if(this.$route.path=="/logmonitoring/reports"){
                this.currentRoute="reports"
            }
    },
    watch:{
        "$route.path":function(val){
            console.log(val);
            if(val=="/logmonitoring/indicatorForm"){
                this.currentRoute="master"
            }
            else if(val=="/logmonitoring/addmonitoringForm"){
                this.currentRoute="monitoring"
            }
            else if(val=="/logmonitoring/reports"){
                this.currentRoute="reports"
            }
        }
    }
};
</script>
